$(document).ready(function() {
  $('#users_profiles_taxation_category_borderer_tax').on('click', function() {
    $('#borderer-form').removeClass('d-none');
    $('#foreigner-form').addClass('d-none');
    $('input', '#borderer-form').prop('required', 'required');
    $('input', '#foreigner-form').prop('required', false);
  });

  $('#users_profiles_taxation_category_foreign_tax_exemption').on('click', function() {
    $('#foreigner-form').removeClass('d-none');
    $('#borderer-form').addClass('d-none');
    $('input', '#foreigner-form').prop('required', 'required');
    $('input', '#borderer-form').prop('required', false);
  });

  $('#users_profiles_taxation_category_income_tax_exemption').on('click', function() {
    $('#borderer-form, #foreigner-form').addClass('d-none');
    $('input', '#borderer-form, #foreigner-form').prop('required', false);
  });

  // Disable submit button if no file is selected
  const submitButton = document.querySelector('#spanish-taxation-submit-button');

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.classList.add('disabled');

    const form = submitButton.closest('form');

    if (form) {
      const fileInput = form.querySelector('.file-field input[type="file"]');

      if (fileInput) {
        fileInput.addEventListener('change', function() {
          if (this.files.length > 0) {
            submitButton.disabled = false;
            submitButton.classList.remove('disabled');
          } else {
            submitButton.disabled = true;
            submitButton.classList.add('disabled');
          }
        });
      }
    }
  }
})
